import { UserType } from "./helpers/types";
import { resources } from "./resources";

interface Link {
  icon: string;
  title: string;
  url: string;
  allowedUserTypes: UserType[];
  dropdown?: any[];
}

const pageSizeStr = localStorage.getItem("BATCH_CREDIT_SAVED_PAGE_SIZE");
const pageSize = pageSizeStr ? Number(pageSizeStr) : 10;

export const initialPaginationData = { pageSize, total: 0, pageNumber: 1 };

export const allLinks: Link[] = [
  {
    icon: resources.icons.REPORT,
    title: "Application Service",
    url: "/app-service",
    allowedUserTypes: ["BCP_ADMIN"]
  },
  {
    icon: resources.icons.REPORT,
    title: "Super Agent",
    url: "/super-agent",
    allowedUserTypes: ["BCP_ADMIN"]
  },
  {
    icon: resources.icons.REPORT,
    title: "Map Acquirer",
    url: "/map-acquirer",
    allowedUserTypes: ["BCP_ADMIN"]
  }
];

export const imageExtensions: any = {
  tiff: true,
  tif: true,
  bmp: true,
  jpg: true,
  jpeg: true,
  gif: true,
  png: true,
  eps: true
};
